import styled from 'styled-components'
import { IconV2 } from 'ui/components/Icon/IconV2'

export const Item = styled.div`
  width: 214px;
  height: 120px;
  border-radius: 4px;
  padding: 12px;

  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  background-color: var(--theme-colors-global-general-main);
  transition: background-color 0.25s;

  &:hover {
    background-color: var(--theme-colors-global-grey-grey100);
  }
`

export const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const LastRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const OverallCount = styled.h2`
  font: var(--theme-typography-h2-semiBold);
`

export const SymbolWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font: var(--theme-typography-bodyM-semiBold);
  color: var(--theme-colors-global-grey-grey900);
`

export const GoToIcon = styled(IconV2)`
  color: var(--theme-colors-global-grey-grey900);
`
